import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const HistoricalStatements = loadable(() => import(/* webpackChunkName: "HistoricalStatements" */ './HistoricalStatements'), {
  fallback: <LoadableFallback visible />,
});

const asyncHistoricalStatements = ({ route }) => (
  <HistoricalStatements route={route} />
);

asyncHistoricalStatements.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncHistoricalStatements;
